import React, {useEffect, useState} from 'react';
import {
    PostContainer, PostWrapper, ImageWrapper, Image, PostContentWrapper, Category, PostTitle, Link
} from './post-slide.style';
import apiFetch from "@wordpress/api-fetch";
import {useGlobal} from "reactn";


export const PostSlide = ({ image, category, date, title, description, link, type }) => {

    const [user] = useGlobal('user');

    function addParamsToBlogLink(link){
        try {
            if(user === undefined) return link
            
            const name = user.name.first + ' ' + user.name.last;
            return link + '?name=' + name + '&email=' + user.email + '&phone=' + user.phone;
        } catch (e){
            return link;
        }
    }

    const [categoryName,setCategoryName] = useState([]);
    useEffect(() => {
        async function getCategoryName() {
            const categoryData = await apiFetch( { path: `/wp-json/wp/v2/categories/${category}` } );
            setCategoryName(categoryData.name);
        }
        getCategoryName();
    }, [category]);

    return (<PostContainer>
        <PostWrapper>
            <ImageWrapper>
                <Link to={addParamsToBlogLink(link)} href={addParamsToBlogLink(link)} target="_blank">
                    <Image src={image}
                         alt="" />
                </Link>
                <Category>{categoryName}</Category>
            </ImageWrapper>
            <PostContentWrapper>
                <PostTitle>
                    <Link to={addParamsToBlogLink(link)} href={addParamsToBlogLink(link)} target="_blank">{title}</Link>
                </PostTitle>
            </PostContentWrapper>
        </PostWrapper>
    </PostContainer>
    );
}
